import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  cancelGooglePost,
  generateGooglePostCaption,
  getGooglePosts,
  updateGooglePostSchedule,
  updateGooglePostQueueItem,
  uploadGooglePosts,
} from "../../api/bReviewsApi";

export const useGenerateGooglePostCaption = (locationId) =>
  useMutation({
    mutationFn: (data) => generateGooglePostCaption(locationId, data),
  });

export const useGetGooglePosts = (organisationId, locationId, enabled = true) =>
  useQuery({
    queryKey: ["google-posts", organisationId, locationId],
    queryFn: () => getGooglePosts(organisationId, locationId),
    enabled: Boolean(organisationId && locationId && enabled),
    refetchInterval: 30 * 1000,
  });

export const useUploadGooglePosts = (organisationId, locationId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (formData) => uploadGooglePosts(locationId, formData),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["google-posts", organisationId, locationId],
      }),
  });
};

export const useCancelGooglePost = (organisationId, locationId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (queueItemId) =>
      cancelGooglePost(organisationId, locationId, queueItemId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["google-posts", organisationId, locationId],
      }),
  });
};

export const useUpdateGooglePostQueueItem = (organisationId, locationId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ queueItemId, data }) =>
      updateGooglePostQueueItem(locationId, queueItemId, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["google-posts", organisationId, locationId],
      }),
  });
};

export const useUpdateGooglePostSchedule = (organisationId, locationId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateGooglePostSchedule(locationId, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["google-posts", organisationId, locationId],
      }),
  });
};
